import getCaps from '@anm/data/streaming/destinationsCaps';
import { useEffect, useState } from 'react';
import { SocialDestination, StreamingNetwork } from 'types/stream';

import { MINS_STEP } from './useStreamTime';

type DestinationErrorProps = {
  date: number | null;
  isScheduled: boolean;
  destinationIds: string[];
  destinations?: SocialDestination[];
};

const useDestinationTimeErrors = ({ date, isScheduled, destinationIds, destinations }: DestinationErrorProps) => {
  const [destinationErrors, setDestinationErrors] = useState<string[]>([]);

  useEffect(() => {
    if (!date) return;

    const d = new Date(date);
    const m = d.getMinutes();
    const roundedMins = m % MINS_STEP === 0 ? m : m + MINS_STEP - (m % MINS_STEP);
    const roundedDate = d.setMinutes(roundedMins);
    const timeDiff = roundedDate - Date.now();

    const selectedDestinations = destinations?.filter(d => destinationIds.includes(d.id)) || [];

    const errors = selectedDestinations.reduce((acc, item) => {
      const kindParam = item.kind ? `.${item.kind}` : '';

      const caps = item.network && getCaps(item.network as StreamingNetwork, item.kind);

      if (!caps) return acc;

      if (
        isScheduled &&
        !acc.includes(`${item.network}${kindParam}-minScheduleInterval`) &&
        caps.minScheduleInterval &&
        timeDiff < caps.minScheduleInterval
      ) {
        acc.push(`${item.network}${kindParam}-minScheduleInterval`);
      }

      if (
        isScheduled &&
        !acc.includes(`${item.network}${kindParam}-maxScheduleInterval`) &&
        caps.maxScheduleInterval &&
        timeDiff > caps.maxScheduleInterval
      ) {
        acc.push(`${item.network}${kindParam}-maxScheduleInterval`);
      }

      return acc;
    }, [] as string[]);

    setDestinationErrors(errors);
  }, [date, isScheduled, destinationIds.length, destinations?.length]);

  return [destinationErrors, setDestinationErrors] as const;
};

export default useDestinationTimeErrors;
